import axios from 'axios'

const baseUrl = process.env.REACT_APP_BACKEND_URL

const createMap = async (data, token) => {

    const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
    }
    
    const response = await axios.post(baseUrl + `/api/creator/createMap`, data, config)
    
    // console.log(response)
    return response.data
}

const getMaps = async (token) => {

    const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
    }

    const response = await axios.get(baseUrl + `/api/creator/getMaps`, config)
    // console.log(response.data)
    
    return response.data
}

const updateMap = async (data, token) => {

    const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
    }
    
    const response = await axios.post(baseUrl + `/api/creator/updateMap`, data, config)
    
    // console.log(response)
    return response.data
}

const addLayer = async (data, token) => {

    const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
    }
    
    const response = await axios.post(baseUrl + `/api/creator/addLayer`, data, config)
    
    // console.log(response)
    return response.data
}

const editLayer = async (data, token) => {

    const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
    }
    
    const response = await axios.post(baseUrl + `/api/creator/editLayer`, data, config)
    
    // console.log(response)
    return response.data
}

const deleteLayer = async (data, token) => {

    const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
    }
    
    const response = await axios.post(baseUrl + `/api/creator/deleteLayer`, data, config)
    
    // console.log(response)
    return response.data
}

const creatorService = {
    createMap, 
    getMaps,
    updateMap,
    
    addLayer,
    editLayer,
    deleteLayer,
}

export default creatorService